// extracted by mini-css-extract-plugin
module.exports = {"root":"PropertyList_root__3FrLW","twoColumns":"PropertyList_twoColumns__3g24t","item":"PropertyList_item__3zRsq"};